export default __webpack_public_path__ + "static/media/lukehickmanweb.ce9b250f.png";